import React,{Component} from "react";
import { Link } from "react-router-dom";
class AddQuestionsBanner extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    return (
      <React.Fragment>
        <div class="banner">
          <div class="container">
            <img src="./../../../assets/img/bg/banner.jpg" alt="" />
            <div class="bg-content">
              <div class="bg-content-detail">
                <div class="bg-tabs-btn">
                  <Link to="#" onClick={this.props.goToQuestionBank} className="btn-add-ques">
                    Add Questions from Question Bank
                  </Link>
                  <a href="#" class="btn-add-ques active">
                    Add New Questions
                  </a>
                </div>
                <div class="bg-detail-fields">
                  <div class="bg-select">
                    <label for="">
                      Chief Complain <span>*</span>
                    </label>
                    <select onChange={this.props.selectComplainType}>
                      <option value="">Please Select Complain Type</option>

                        {Object.values(this.props.complainTypes).map((row, key) => (
                          <option value={`${row.id}`}>{row.name}</option>
                        ))}
                      </select>
                    
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default AddQuestionsBanner;
